import { SportsBasePage, TrackingInfo } from "./base/base-page/sports-base-page";
export { SportsBasePage, TrackingInfo } from "./base/base-page/sports-base-page";
import { CreaTuApuestaPage } from "./betbuilder/betbuilder.page";
export { CreaTuApuestaPage } from "./betbuilder/betbuilder.page";
import { BetslipUnlockerPage } from "./betslip-unlocker/betslip-unlocker.page";
export { BetslipUnlockerPage } from "./betslip-unlocker/betslip-unlocker.page";
import { CodereFantasyPage } from "./codere-fantasy/codere-fantasy.page";
export { CodereFantasyPage } from "./codere-fantasy/codere-fantasy.page";
import { CuotaChangePage } from "./cuota-change/cuota-change-page/cuota-change.page";
export { CuotaChangePage } from "./cuota-change/cuota-change-page/cuota-change.page";
import { EventoPage } from "./event/event-page/event.page";
export { EventoPage } from "./event/event-page/event.page";
import { EventoSpecialPage } from "./evento-especial/evento-special-page/evento-special.page";
export { EventoSpecialPage } from "./evento-especial/evento-special-page/evento-special.page";
import { FreeBetsPage } from "./free-bets/free-bets-page/free-bets.page";
export { FreeBetsPage } from "./free-bets/free-bets-page/free-bets.page";
import { HomePage } from "./home/home-page/home.page";
export { HomePage } from "./home/home-page/home.page";
import { DirectosPage } from "./live/live-page/live.page";
export { DirectosPage } from "./live/live-page/live.page";
import { NowLiveDetailPage } from "./live-market/live-market-page/live-market.page";
export { NowLiveDetailPage } from "./live-market/live-market-page/live-market.page";
import { MercadosPage } from "./market-page/market-page/market.page";
export { MercadosPage } from "./market-page/market-page/market.page";
import { MisApuestasPresencialesPage } from "./mis-apuestas-presenciales/mis-apuestas-presenciales-page/mis-apuestas-presenciales.page";
export { MisApuestasPresencialesPage } from "./mis-apuestas-presenciales/mis-apuestas-presenciales-page/mis-apuestas-presenciales.page";
import { MyBetsPage } from "./my-bets/my-bets-page/my-bets.page";
export { MyBetsPage } from "./my-bets/my-bets-page/my-bets.page";
import { ProxyComponent } from "./proxy/proxy-page/proxy.page";
export { ProxyComponent } from "./proxy/proxy-page/proxy.page";
import { HorsesPage } from "./race/race-page/race.page";
export { HorsesPage } from "./race/race-page/race.page";
import { HorsesMarketPage } from "./race-market/race-market-page/race-market.page";
export { HorsesMarketPage } from "./race-market/race-market-page/race-market.page";
import { SpecialTeamPage } from "./special-team/special-team-page/special-team.page";
export { SpecialTeamPage } from "./special-team/special-team-page/special-team.page";
import { SportCountriesPage } from "./sport-countries/sport-countries-page/sport-countries.page";
export { SportCountriesPage } from "./sport-countries/sport-countries-page/sport-countries.page";
import { SportEventsPage } from "./sport-events/sport-events-page/sport-events.page";
export { SportEventsPage } from "./sport-events/sport-events-page/sport-events.page";
import { TicketFreebetsPage } from "./ticket-freebets/ticket-freebets-page/ticket-freebets.page";
export { TicketFreebetsPage } from "./ticket-freebets/ticket-freebets-page/ticket-freebets.page";
import { TodayPage } from "./today/today-page/today.page";
export { TodayPage } from "./today/today-page/today.page";

export const SportPages: any[] = [
  TrackingInfo,
  SportsBasePage,
  CreaTuApuestaPage,
  BetslipUnlockerPage,
  CodereFantasyPage,
  CuotaChangePage,
  EventoPage,
  EventoSpecialPage,
  FreeBetsPage,
  HomePage,
  DirectosPage,
  NowLiveDetailPage,
  MercadosPage,
  MisApuestasPresencialesPage,
  MyBetsPage,
  ProxyComponent,
  HorsesPage,
  HorsesMarketPage,
  SpecialTeamPage,
  SportCountriesPage,
  SportEventsPage,
  TicketFreebetsPage,
  TodayPage,
];
